// @source 40 CFR Part 261 — Identification and Listing of Hazardous Waste,
// via eCFR Versioner API. Data lives in rcraCatalogue.generated.ts
// (rebuild: node frontend/scripts/generateRcraCatalogue.mjs).
import { RCRA_GENERATED } from './rcraCatalogue.generated';

export type RcraList = 'D' | 'F' | 'K' | 'P' | 'U';
export type RcraHazardBasis =
  | 'ignitable' | 'corrosive' | 'reactive' | 'toxic-characteristic'
  | 'listed-toxic' | 'listed-acute';

export interface RcraEntry {
  code: string;
  codeSlug: string;
  list: RcraList;
  description: string;
  hazardBasis: RcraHazardBasis;
  contaminant?: string;
  regulatoryLevel?: string;
  industrySource?: string;
  casNumber?: string;
  sourceUrl: string;
}

export const RCRA_CATALOGUE: RcraEntry[] = RCRA_GENERATED;

export const RCRA_LISTS: Record<RcraList, { title: string; blurb: string }> = {
  D: {
    title: 'Characteristic Hazardous Wastes',
    blurb: 'Wastes that are hazardous because of what they do, not where they come from: ignitability (D001), corrosivity (D002), reactivity (D003), or toxicity (D004-D043, defined by TCLP contaminant thresholds). Any industrial waste stream can carry a D code.',
  },
  F: {
    title: 'Wastes From Non-Specific Sources',
    blurb: 'Manufacturing process wastes that arise across many industries: spent solvents (F001-F005), electroplating and metal finishing wastes (F006-F019), and others. The code follows the process, not the industry.',
  },
  K: {
    title: 'Wastes From Specific Industries',
    blurb: 'Source-specific wastes from 13 named industries, including petroleum refining, wood preservation, pesticide manufacturing and iron and steel production. Each K code names both the industry and the exact process residue.',
  },
  P: {
    title: 'Acutely Hazardous Discarded Chemicals',
    blurb: 'Unused commercial chemical products that are acutely hazardous when discarded — even in small quantities. One kilogram per month can make a site a large-quantity generator.',
  },
  U: {
    title: 'Toxic Discarded Chemical Products',
    blurb: 'Unused commercial chemical products that are toxic when discarded, from acetone (U002) to solvents and manufacturing intermediates. The code applies to the unused chemical, not process waste containing it.',
  },
};

const bySlug = new Map(RCRA_CATALOGUE.map((e) => [e.codeSlug, e]));
const byCode = new Map(RCRA_CATALOGUE.map((e) => [e.code, e]));

export function resolveRcraSlug(slug: string): RcraEntry | undefined {
  return bySlug.get(slug.toLowerCase().trim());
}

export function getRcraEntry(code: string): RcraEntry | undefined {
  return byCode.get(code.toUpperCase().trim());
}

export function getRcraListEntries(list: RcraList): RcraEntry[] {
  return RCRA_CATALOGUE.filter((e) => e.list === list);
}
